import type { QueryClientConfig } from "@tanstack/react-query"
import { AdminApiError } from "./api.js"

export const adminQueryCacheMs = 30_000
export const adminQueryGarbageCollectionMs = 5 * 60_000
export const adminQueryRetryDelayMs = 250

export function shouldRetryAdminQuery(failureCount: number, error: unknown) {
  if (failureCount >= 1) {
    return false
  }
  if (error instanceof DOMException && error.name === "AbortError") {
    return false
  }
  return !(error instanceof AdminApiError) || error.status >= 500
}

export const adminQueryClientConfig: QueryClientConfig = {
  defaultOptions: {
    mutations: {
      retry: false,
    },
    queries: {
      gcTime: adminQueryGarbageCollectionMs,
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
      retry: shouldRetryAdminQuery,
      retryDelay: adminQueryRetryDelayMs,
      staleTime: adminQueryCacheMs,
    },
  },
}
